// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#38d39f","secondaryColor":"#39374E"};